import type { TopicListItem, TopicObject } from '@/types'

// Список тем с бэка гетерогенный: на верхнем уровне лежат и сами темы, и группы,
// внутри которых темы вложены в group.topics. Любой поиск по id обязан спускаться
// в группы, иначе вложенные темы «не находятся».

/** Плоский список тем: верхний уровень + дети групп. Сами группы в результат не попадают. */
export function flattenTopics(items: TopicListItem[]): TopicObject[] {
	const result: TopicObject[] = []
	for (const item of items ?? []) {
		if (item.element_type === 'group') {
			result.push(...(item.topics ?? []))
		} else {
			result.push(item)
		}
	}
	return result
}

/**
 * Поиск темы по id по всему дереву.
 * Матчит только element_type === 'topic': id группы и id темы могут совпасть,
 * и тогда плоский find вернул бы группу.
 */
export function findTopicById(items: TopicListItem[], id?: number | string | null): TopicObject | undefined {
	if (id === null || id === undefined || id === '') return undefined
	const target = Number(id)
	if (Number.isNaN(target)) return undefined
	return flattenTopics(items).find((topic) => Number(topic.id) === target)
}
